import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


// function AppWrapper({ children }) {
//   return (
//     <div
//       style={{
//         width: '80vw',       // 80% of viewport width
//         height: '80vh',      // 80% of viewport height
//         margin: '0 auto',    // center horizontally
//         overflow: 'auto',    // allow scrolling if content is bigger
//         boxSizing: 'border-box',
//       }}
//     >
//       {children}
//     </div>
//   );
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>
    {/* <AppWrapper> */}
    <App />
    {/* </AppWrapper> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
